import { Provider } from '@angular/core';

import { FirebaseAnalyticsUseCasesImpl } from '@app/domain/use-cases/firebase-analytics/firebase-analytics.use-cases';
import { FIREBASE_ANALYTICS_USE_CASES } from '@app/domain/use-cases/firebase-analytics/firebase-analytics.use-cases.contract';

export const firebaseAnalyticsUseCasesProvider: Provider = {
  provide: FIREBASE_ANALYTICS_USE_CASES,
  useClass: FirebaseAnalyticsUseCasesImpl
};
